import React from 'react';
import propTypes from 'prop-types';
import { UiTooltip } from './UiTooltip';

export function UiFieldset({ children, tooltip, title, className }) {
  return (
    <fieldset className={className}>
      <header>
        <legend>
          {title}
          {tooltip && <UiTooltip content={tooltip} />}
        </legend>
      </header>
      {children}
    </fieldset>
  );
}

UiFieldset.defaultProps = {
  tooltip: null,
  className: '',
};

UiFieldset.propTypes = {
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node,
  ]).isRequired,
  title: propTypes.string.isRequired,
  tooltip: propTypes.string,
  className: propTypes.string,
};
